module.exports = __webpack_public_path__ + "img/favorites-outline.e58ebf1.svg?v=1764327952164";